/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TriggerButton = styled(Button)({
  padding: `0 ${gridSize() / 2}px`,
  '& span': {
    margin: 0,
  },
});

export const DropdownGroupProjects = styled.div({
  overflowY: 'auto',
  maxHeight: `${gridSize() * 30}px`,
});

export const ManageProjectsItem = styled.div({
  borderTop: `1px solid ${token('color.border', colors.N30)}`,
});

export const DropdownInnerWrapper = styled.div({
  width: `${gridSize() * 37.5}px`,
  maxHeight: `${gridSize() * 45}px`,
});

export const DropdownMessage = styled.div({
  width: `${gridSize() * 37.5}px`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

export const NoRelevantProjectMessage = styled.div({
  margin: `${gridSize() * 2}px`,
  width: `${gridSize() * 30}px`,
  whiteSpace: 'initial',
});
